import { clinicasApi } from '../../../api';
import { addNotification, clearMensajes, clearNotifications, clearTipoMembresia, removeNotification, setMensajes, setTipoMembresia } from './uiSlice';

const moment = require('moment');


export const successNotification = (content) => {
    return async(dispatch) => {

        let id = moment().unix() + Math.random();

        dispatch(addNotification({ id, content, type: 'success' }));

        setTimeout(() => {
            dispatch(removeNotification(id));
        }, 5000);

    }
}

export const infoNotification = (content) => {
    return async(dispatch) => {

        let id = moment().unix() + Math.random();

        dispatch(addNotification({ id, content, type: 'info' }));

        setTimeout(() => {
            dispatch(removeNotification(id));
        }, 3000);

    }
}

export const warningNotification = (content) => {
    return async(dispatch) => {

        let id = moment().unix() + Math.random();

        dispatch(addNotification({ id, content, type: 'warning' }));

        setTimeout(() => {
            dispatch(removeNotification(id));
        }, 3000);

    }
}

export const dangerNotification = (content) => {
    return async(dispatch) => {

        let id = moment().unix() + Math.random();

        dispatch(addNotification({ id, content, type: 'danger' }));

        setTimeout(() => {
            dispatch(removeNotification(id));
        }, 3000);

    }
}

export const startTipoMembresia = (membresia) => {
    return async(dispatch) => {

        try {

            let resp = await clinicasApi.get(`/usuarios/perfil?membresia=${encodeURIComponent(membresia)}`);

            if (resp.status) {

                dispatch(setTipoMembresia(resp.data.tipoMembresia));
                dispatch(clearNotifications());

                return true;

            } else {

                dispatch(clearTipoMembresia());
                dispatch(clearNotifications());
                dispatch(dangerNotification(resp.data.msg));

            }

            return false;

        } catch (error) {

            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {

                dispatch(clearTipoMembresia());
                dispatch(clearNotifications());
                dispatch(dangerNotification(error.response.data.msg));

            } else {

                dispatch(clearTipoMembresia());
                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

            }

            return false;

        }

    }
}

export const startGetMensajes = () => {
    return async(dispatch) => {

        try {

            let resp = await clinicasApi.get('/education/custommessages');

            if (resp.status) {

                dispatch(setMensajes(resp.data.value));
                dispatch(clearNotifications());

                return true;

            } else {

                dispatch(clearMensajes());
                dispatch(clearNotifications());
                dispatch(dangerNotification(resp.data.msg));

            }

            return false;

        } catch (error) {

            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {

                dispatch(clearMensajes());
                dispatch(clearNotifications());
                dispatch(dangerNotification(error.response.data.msg));

            } else {

                dispatch(clearMensajes());
                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

            }

            return false;

        }

    }
}